var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bl-input-component flex-shrink-0",
      attrs: { "data-id": _vm.input.id }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        staticClass: "bl-input",
        attrs: {
          type: "text",
          id: "bl-input-" + _vm.id,
          "data-id": _vm.input.id,
          placeholder: _vm.input.placeholder
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bl-input-border" }),
      _vm._v(" "),
      _c("BlIcon", {
        staticClass: "bl-input-icon",
        attrs: {
          clickable: true,
          icon: !!_vm.value ? "close" : "search",
          "data-id": _vm.input.id
        },
        on: {
          clicked: function($event) {
            _vm.value = ""
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d53b930", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d53b930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlInputSearch.vue
// module id = null
// module chunks = 